import { getGetApiV2ObjectBookingMemberBookingsQueryKey, useDeleteApiV2ObjectBookingMemberBookingsBookingId } from '@shared/integrations/taf-api/v2/features/object-booking/object-booking.ts';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useToast } from '@shared/features/toasts/contexts/ToastProvider.tsx';
import { AccommodationBookingObjectDto } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { IBooking } from '@shared/integrations/taf-api/v2/models';
import { dateTimeStringToDate } from '../utils/calendarUtils';

interface ICancelBookingButton {
    booking: IBooking;
    object: AccommodationBookingObjectDto;
}

const CancelBookingButton = ({ booking, object }: ICancelBookingButton) => {
    const { mutate } = useDeleteApiV2ObjectBookingMemberBookingsBookingId();
    const [isLoading, setIsLoading] = useState<boolean>();
    const queryClient = useQueryClient();
    const { infoToast, dangerToast } = useToast();
    const handleOnDeleteClick = () => {
        if (!booking.id) {
            dangerToast('Fel vid avbokning, kunde inte hitta boknings id');
            return;
        }
        setIsLoading(true);
        mutate(
            { bookingId: booking.id },
            {
                onSuccess: async () => {
                    queryClient.refetchQueries({ queryKey: getGetApiV2ObjectBookingMemberBookingsQueryKey() }).then(() => {
                        setIsLoading(false);
                        infoToast(
                            `<h5 className='mb-2'>${object.name} avbokad</h5> <p className='mb-0'>${object.name} är nu avbokad för perioden ${booking.startDate ? dateTimeStringToDate(booking.startDate) : 'N/A'} - ${booking.endDate ? dateTimeStringToDate(booking.endDate) : 'N/A'}</p>`,
                        );
                    });
                },
                onError: () => {
                    dangerToast('Fel vid avbokning');
                    setIsLoading(false);
                },
            },
        );
    };

    return (
        <button
            className='btn btn-danger'
            onClick={handleOnDeleteClick}
        >
            {!isLoading ? 'Avboka' : <div className='spinner-linear spinner spinner-white my-1 mx-auto'></div>}
        </button>
    );
};

export default CancelBookingButton;
